import styles from "../styles/Components/new-dashboard/TopCommunityBots.module.css";
import { FaBolt } from "react-icons/fa6";
import { BsHourglassSplit } from "react-icons/bs";
import EmptyBox from "../ui/EmptyBox";
import CommunityBotItem from "../components/new-dashboard/top-community-bot/CommunityBotItem";
import { useSelector } from "react-redux";
import { useState } from "react";

function CommunityBotsContent() {
  const {
    dashboard: { botInfoStatus, communityBots },
  } = useSelector((state) => state);

  const [activeTab, setActiveTab] = useState("short");

  const {
    one_month: bots1st = [],
    two_months: bots2nd = [],
    three_months: bots3nd = [],
  } = communityBots;

  const bots =
    activeTab === "short" ? bots1st : bots2nd?.length > 0 ? bots2nd : bots3nd;
  const profitDivisionFactor =
    activeTab === "short" ? 1 : bots2nd?.length > 0 ? 2 : 3;

  const changeTab = (tab) => () => setActiveTab(tab);

  return (
    <>

      {botInfoStatus === "success" && (
        <>
          <p style={{ marginBottom: "0" }}>
            Discover and explore some of the best-performing bots created by our
            community members.
          </p>
          <div className={styles.tabs}>
            <div
              className={`${styles.tab} ${activeTab === "short" ? styles.activeTab : ""}`}
              onClick={changeTab("short")}
            >
              <FaBolt />
              Short Term
            </div>
            <div
              className={`${styles.tab} ${activeTab === "long" ? styles.activeTab : ""}`}
              onClick={changeTab("long")}
            >
              <BsHourglassSplit />
              Long Term
            </div>
          </div>
          <div className={styles.botsWrapper}>
            {bots?.length === 0 && (
              <div className={styles.emptyMessage}>
                <EmptyBox useCase="table" size={50} color="#495057" />
                Not available data for now
              </div>
            )}

            {bots.map((bot, i) => (
              <CommunityBotItem
                key={`${activeTab}-${bot?.bot_creation_id || bot?.bot_name || i}`}
                data={bot}
                divisionFactor={profitDivisionFactor}
              />
            ))}
          </div>
        </>
      )}
    </>
  );
}

export default CommunityBotsContent;
